module.exports = __webpack_public_path__ + "static/img/il.5d16f002.svg";